import { render, staticRenderFns } from "./publicity.vue?vue&type=template&id=5af00f34&scoped=true&"
import script from "./publicity.vue?vue&type=script&lang=js&"
export * from "./publicity.vue?vue&type=script&lang=js&"
import style0 from "./publicity.vue?vue&type=style&index=0&id=5af00f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af00f34",
  null
  
)

export default component.exports